export default __webpack_public_path__ + "static/media/Tutorials-documentation.e7f0ea3f.md";